<div>
    <div class="nav-container-1">
      <form [formGroup]="searchForm">
        <div class="row">
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <EIPAutoComplete TextField="projCodeDesc" ValueField="projectId" WaterMarkText="Project"
              formControlName="ctrlProject" setId="ddlProject" ShowTextValueField='N' [dataSource]='projectList'
              [defaultValue]="selectedProject" [SingleValueBind]="false" [IsCascading]='true'
              (valueChange)='setSelectedProject($event)'>
            </EIPAutoComplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Discipline"
              formControlName="ctrlDiscipline" setId="ddlDisc" ShowTextValueField='N' [dataSource]='disciplineDetails'
              [defaultValue]="selectedDiscipline" [SingleValueBind]="false" [IsCascading]='true'
              (valueChange)='setSelectedDiscipline($event)'>
            </EIPAutoComplete>
          </div>
          <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-xs-12">
            <EIPAutoComplete TextField="dedDescription" ValueField="dedId" WaterMarkText="Stages"
            formControlName="ctrlStage" setId="ddlStage" ShowTextValueField='N' [dataSource]='StageDetails'
            [defaultValue]="selectedStage" [SingleValueBind]="false" [IsCascading]='true'
            (valueChange)='setSelectedStage($event)'>
          </EIPAutoComplete>
        </div>
        </div>
      </form>
    </div>
  
    <div>
    <div class="dashboard-container" *ngIf="!!projectId">
        <div class="row row-10 eip-mt-20">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">GFC Planned Vs Actual</p></div>

                    <div class="eip-pt-0">
                        <kendo-chart>
                            <kendo-chart-title></kendo-chart-title>
                            <kendo-chart-legend [title]="{ text: 'Revision' }" position="bottom">
                            </kendo-chart-legend>
                            <kendo-chart-series>
                                <kendo-chart-series-item
                                *ngFor="let item of drawingGFCDetails"
                                type="line"
                                [name]="item.status"
                                [data]="item.doc_Count" 
                                [labels]="seriesLabels"
                                ></kendo-chart-series-item>
                            </kendo-chart-series>
                          <kendo-chart-category-axis>
                                <kendo-chart-category-axis-item
                                  [categories]="category"></kendo-chart-category-axis-item>
                              </kendo-chart-category-axis>
                           
                          </kendo-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Schedule Adherance</p></div>

                    <div>
                        <kendo-chart [transitions]="true">
                            <kendo-chart-title text="Schedule Adherance" color="white"></kendo-chart-title>
                            <kendo-chart-series>
                                <kendo-chart-series-item type="pie"  [data]="dciAdherenceDetails" field="doc_Count"
                                    categoryField="delay_Reason" colorField="color" [autoFit]="false">
                                    <kendo-chart-series-item-labels  [align]="center"
                                    color="#000"
                                    [content]="labelContent">
                                    </kendo-chart-series-item-labels>
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-dataItem="dataItem">
                                    {{ category }} -  {{ dataItem.doc_Count }} 
                                </ng-template>
                            </kendo-chart-tooltip>
                            <kendo-chart-legend position="bottom" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>
           
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Revision Wise Approval Count</p></div>
                    <div>

                        <kendo-chart>
                            <!-- <kendo-chart-title text="Engineering Schedule Document Status"></kendo-chart-title> -->
                            <kendo-chart-series>
                                <kendo-chart-series-item type="column" [data]="dciRevWiseDetails" field="doc_Count"
                                    categoryField="status" colorField="color" [dynamicHeight]="dynamicHeight" [gap]="2.5" [spacing]="0.25">
                                    <kendo-chart-series-item-labels background="none" color="white" format="N0">
                                    </kendo-chart-series-item-labels>
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-dataItem="dataItem">
                                    {{ category }} -  {{ dataItem.doc_Count }} 
                                </ng-template>
                            </kendo-chart-tooltip>
                            <kendo-chart-legend position="bottom" [title]="legendTitle" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Stage Wise Approval Count</p></div>
                    <div>

                        <kendo-chart>
                            <!-- <kendo-chart-title text="Engineering Schedule Document Status"></kendo-chart-title> -->
                            <kendo-chart-series>
                                <kendo-chart-series-item type="column" [data]="dciStageWiseDetails" field="doc_Count"
                                    categoryField="status" colorField="color" [dynamicHeight]="dynamicHeight" [gap]="2.5" [spacing]="0.25">
                                    <kendo-chart-series-item-labels background="none" color="white" format="N0">
                                    </kendo-chart-series-item-labels>
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-dataItem="dataItem">
                                    {{ category }} -  {{ dataItem.doc_Count }} 
                                </ng-template>
                            </kendo-chart-tooltip>
                            <kendo-chart-legend position="bottom" [title]="legendTitle" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Discipline Wise Count</p></div>
                    <div>

                        <kendo-chart>
                            <!-- <kendo-chart-title text="Engineering Schedule Document Status"></kendo-chart-title> -->
                            <kendo-chart-series>
                                <kendo-chart-series-item type="bar" [data]="dciDiscWiseDetails" field="doc_Count"
                                    categoryField="status" colorField="color" [dynamicHeight]="dynamicHeight" [gap]="2.5" [spacing]="0.25">
                                    <kendo-chart-series-item-labels background="none" color="white" format="N0">
                                    </kendo-chart-series-item-labels>
                                </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="category" let-dataItem="dataItem">
                                    {{ category }} -  {{ dataItem.doc_Count }} 
                                </ng-template>
                            </kendo-chart-tooltip>
                            <kendo-chart-legend position="bottom" [title]="legendTitle" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>

            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Revisions Stage Wise Count</p></div>
                    <div>

                        <kendo-chart>
                            <!-- <kendo-chart-title text="Engineering Schedule Document Status"></kendo-chart-title> -->
                            <kendo-chart-category-axis>
                                <kendo-chart-category-axis-item
                                  [categories]="dciCategories">
                                </kendo-chart-category-axis-item>
                              </kendo-chart-category-axis>
                            <kendo-chart-series>
                                <kendo-chart-series-item
                                *ngFor="let item of dciStageRevDetails; let index=index"
                                type="bar" [stack]="true"
                                [name]="item.status"
                                [data]="item.doc_Count"
                                [labels]="seriesLabels"
                                [color]="getStatusColor(index)"
                                ></kendo-chart-series-item>
                            </kendo-chart-series>   
                            <!-- <kendo-chart-tooltip>
                                <ng-template kendoChartSeriesTooltipTemplate let-category="status" let-dataItem="dataItem">
                                    {{ dataItem.doc_Count }} 
                                </ng-template>
                            </kendo-chart-tooltip> -->
                            <kendo-chart-legend position="bottom" [title]="legendTitle" [visible]="true"></kendo-chart-legend>
                        </kendo-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                <div class="eip-panel-body eip-pxy-10">

                    <div  class="eip-panel-header"><p class="fs-16 ff-3">Man Hours</p></div>
                    <div>

                        <kendo-chart>
                            <ng-template kendoChartDonutCenterTemplate>
                              <h3>{{manHour}}</h3>
                              Hours
                            </ng-template>
                            <kendo-chart-series>
                              <kendo-chart-series-item
                                  type="donut" [data]="data" colorField="color"
                                  categoryField="status" field="actual_Manhour">
                                <kendo-chart-series-item-labels
                                  
                                  color="#fff" background="none">
                                </kendo-chart-series-item-labels>
                              </kendo-chart-series-item>
                            </kendo-chart-series>
                            <kendo-chart-legend [visible]="false"></kendo-chart-legend>
                          </kendo-chart>
                        
                    </div>
                </div>
            </div>
        </div>